module.exports = __webpack_public_path__ + "static/media/HR.21310312.svg";